import { IconButton, IconButtonProps } from '@chakra-ui/react';
import { QIcon, QIconProps } from '../..';
import React from 'react';
import { IconNameType } from '../../types/Icons';

export interface QIconButtonProps
  extends Pick<
    IconButtonProps,
    'isLoading' | 'onClick' | 'size' | 'isDisabled' | 'aria-label' | 'icon'
  > {
  iconName: IconNameType;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  variant?: Extract<IconButtonProps['variant'], 'ghost' | 'outline'>;
  isActive?: boolean;
  color?: QIconProps['color'];
}

export const QIconButton = React.forwardRef<
  HTMLButtonElement,
  QIconButtonProps
>((props, ref) => {
  const { iconName, variant = 'ghost', isActive, color, ...rest } = props;

  return (
    <IconButton
      {...rest}
      ref={ref}
      variant={variant}
      icon={<QIcon iconName={iconName} size={props.size} color={color} />}
      isActive={isActive}
    />
  );
});

QIconButton.displayName = 'QIconButton';
